"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Notebook___StyledSvg",
  componentId: "sc-1d10i0j-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Notebook(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M395.863 30.131c24.953 0 45.246 18.805 45.246 41.975v335.8c0 23.15-20.293 41.975-45.246 41.975h-271.48c-24.953 0-45.246-18.825-45.246-41.975v-41.975H33.891v-41.975h45.246v-62.962H33.891v-41.975h45.246v-62.963H33.891v-41.975h45.246V72.106c0-23.17 20.293-41.975 45.247-41.975h271.479zm-271.48 377.775h271.502l-.022-335.8h-271.48v41.975h22.624v41.975h-22.623v62.963h22.623v41.975h-22.623v62.962h22.623v41.975h-22.623v41.975z"
  }));
}

var _default = Notebook;
exports["default"] = _default;